import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useFeatures } from "./featureContext";


export const extractFeaturesFromRoles = (roles = []) => {
  const featureSet = new Set();

  roles.forEach(role => {
    if (Array.isArray(role.features)) {
      role.features.forEach(feature => featureSet.add(feature));
    }
  });

  return Array.from(featureSet);
};

export const FEATURES = {
  ASSET_BROWSER: "AssetBrowser",
  ASSET_DASHBOARD: "AssetDashboard",
  ASSET_FILETOMACHINE: "FileToMachine",
  ASSET_REGISTRATION: "AssetRegistration",
  ASSET_MUTE: "AssetMute",
  GLOBAL_AUDIT_LOGS: "GlobalAuditLogs",
  USER_MANAGEMENT: "UserManagement",
  SCM_ADMIN: "SCM_Admin",
  SCM_PACKAGE: "SCM_Package",
  SCM_DEPLOYMENT: "SCM_Deployment",
};

export const SoftwareManagementIndex = () => {
  const navigate = useNavigate();
  const { features, loading } = useFeatures();

  useEffect(() => {
    if (loading) return;

    if (features.includes(FEATURES.SCM_ADMIN)) {
      navigate("find-package", { replace: true });
      return;
    }

    // Priority order (business decision)
    if (features.includes(FEATURES.SCM_PACKAGE)) {
      navigate("find-package", { replace: true });
      return;
    }

    if (features.includes(FEATURES.SCM_DEPLOYMENT)) {
      navigate("find-package-deployment", { replace: true });
      return;
    }

    // Optional hard fallback
    navigate("/", { replace: true });
  }, []);

  return null;
};